import { CarrierSubmissionSearchItem } from 'types';
import { CapitolaClient } from './base';

export default class CarrierSubmissionClient extends CapitolaClient<CarrierSubmissionSearchItem> {
  public get resourceName(): string {
    return 'carrier-submission';
  }
}
